const dataGridModel = {
    assessments: "assessments",
    perform_assessments: "perform_assessments",
    last_assessments: "last_assessments",
    admin_assessments: "admin_assessments",
    word_frequency: "word_frequency",
    tickets: "tickets",
    test_takers: "test_takers",
    users: "users",
    affiliation_team: "affiliation_team",
    assessment_battery: "assessment_battery",
    affiliation_test_takers: "affiliation_test_takers",
    assessment_library: "assessment_library",
    affiliations: "affiliations",
    test_takers_assessments: "test_takers_assessments",
    learning_units: "learning_units",
    learning_group: "learning_group",
    school_classes: "school_classes"
}

export default dataGridModel